import { render, staticRenderFns } from "./UnKnowPage.vue?vue&type=template&id=06dc5e78&scoped=true&"
import script from "./UnKnowPage.vue?vue&type=script&lang=js&"
export * from "./UnKnowPage.vue?vue&type=script&lang=js&"
import style0 from "./UnKnowPage.vue?vue&type=style&index=0&id=06dc5e78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dc5e78",
  null
  
)

export default component.exports